import config from './config';

const order = config({
  /** Defaults for all sites and locales. */
  default: {
    /** Default settings for all languages. */
    default: {
      /** Settings related to order history. */
      orderHistory: {
        /**
         * The amount of items to show per page in order histories.
         * A value of 7 was causing timeouts in AWS.
         */
        pageSize: 3
      },

      /**
       * Shows the cancel order button during certain order statuses.
       */
      showCancelOrder: false,

      /** Enable/disable order cancellation. */
      orderCancellation: {
        confirmation: { enabled: true },
        details: { enabled: true }
      },
      /**
       * The initial revalidation time in milliseconds to revalidate the order
       * cancellation status if needed. Starts at 5 seconds.
       */
      initialRevalidationTimeForOrderCancelStatus: 5 * 1_000,
      /**
       * The max amount of time to lookup the order cancel status. It's currently
       * set to a maximum of 15 minutes.
       */
      orderCancelStatusTimeout: 15 * 60 * 1_000
    }
  }
});

export default order;
